var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.route)?_c('div',[_c('el-button',{staticClass:"go-to-button",attrs:{"size":"small"},on:{"click":function($event){return _vm.goTo(_vm.route)}}},[_c('span',{staticClass:"go-to-button__content"},[_vm._v(" "+_vm._s(_vm.text)+" "),_c('i',{class:_vm.icon})])])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }